<template>
  <div>
    <div class="wrapAll clearfix">
      <HpSidebar />
      <slot />
    </div>
  </div>
</template>

<script>
import HpSidebar from '@/components/hp/HpSidebar.vue';

export default {
  name: "HpLayout",
  components: {
    HpSidebar,
  },
};
</script>

<style scoped>

.wrapAll {
  width: 100%;
}

.mainsection {
  margin: 0 0 0 11em;
}

.headerLinks {
  text-align: right;
  padding: 0.8em 1.4em;
  font-size: 0.72em;
  color: #777;
  letter-spacing: 0.017em;
}
.headerLinks a {
  display: inline-block;
  margin: 0 0 0 0.5em;
}

.tabs {
}
.tabs ul li a {
  display: block;
  background: url(../assets/hp/img/blue-gradient.png) bottom left repeat-x transparent;
  font-size: 0.85em;
  padding: 1em 0.5em 0;
  line-height: 2em;
  position: relative;
  top: 1px;
  left: 1px;
  border-bottom: 1px solid #a7d7f9;
}
.tabs ul li a.active {
  background: #fff;
  border-bottom-color: transparent;
}
.tabs ul {
  display: inline-block;
  background: url(../assets/hp/img/tab-separator.png) repeat-x top left transparent;
  letter-spacing: 0;
  margin: 0;
  padding: 0 1px 0 0;
}
.tabs ul li {
  margin: 0;
  padding: 0;
  white-space: nowrap;
  display: inline-block;
  float: left;
  margin: 0 1px 0 0px;
}
.tabs ul {
}
.tabsLeft {
  line-height: 0;
  float: left;
}
#simpleSearch {
  margin: 1em 1em 0em 0.5em;
  display: block;
  width: 267px;
  height: 23px;
  padding: 0 0 0 3px;
  float: right;
  overflow: hidden;
  border: solid 1px #aaa;
  background: #f6f6f6;
  background: -moz-linear-gradient(top, #f6f6f6 0%, #ffffff 100%);
  background: -webkit-linear-gradient(top, #f6f6f6 0%, #ffffff 100%);
  background: linear-gradient(to bottom, #f6f6f6 0%, #ffffff 100%);
}
#searchInput {
  background: transparent;
  border: none;
  vertical-align: top;
  height: 23px;
  width: 239px;
  font-size: 0.8em;
}
#submitSearch {
  background-image: url(../assets/hp/img/search.png);
  display: inline-block;
  background-position: center center;
  background-repeat: no-repeat;
  height: 23px;
  width: 23px;
  cursor: pointer;
}
.tabsRight {
  float: right;
  line-height: 0;
}

.pagefooter {
  padding: 1.5em 1.3em 2em;
  font-size: 75%;
  line-height: 2em;
}
.pagefooter a {
  display: inline-block;
  margin-right: 1em;
}
@media screen and (max-width: 850px) {
  #searchInput {
    width: 110px;
  }
  #simpleSearch {
    width: 138px;
  }
}
@media screen and (max-width: 700px) {
  .tabsRight {
    display: none;
  }
}
@media screen and (max-width: 550px) {
  .sidebar {
    width: 6em;
    padding: 3px 0.5em 10px 0.5em;
  }
  .mainsection {
    margin: 0 0 0 7em;
  }
  .contentsPanel {
    width: auto;
  }
}
@media screen and (max-width: 400px) {
  #simpleSearch {
    display: none;
  }
}
@media screen and (max-width: 390px) {
  .rightbox {
  border: 1px solid #a2a9b1;
  border-spacing: 3px;
  background-color: #f8f9fa;
  color: black;
  padding: 0.2em;
  float: right;
  clear: right;
  text-align: left;
  font-size: 88%;
  line-height: 1.5em;
  width: 19em;
}
}

@media screen and (max-width: 550px) {
  .sidebar {
    width: 6em;
    padding: 3px 0.5em 10px 0.5em;
  }
  .mainsection {
    margin: 0 0 0 7em;
  }
}
</style>